import { DivButton } from './DivButton';
import { CloseIcon } from '../../assets/icons';
import React, { ReactElement } from 'react';
import clsx from 'clsx';

export const ModalHeader = (props: {
  title: string;
  subTitle?: string;
  titleIcon?: ReactElement;
  inlineTitleIcon?: boolean;
  centerTitle?: boolean;
  titleClassName?: string;
  handleClose: () => void;
}) => {
  const { title, subTitle, titleIcon, inlineTitleIcon, centerTitle, titleClassName, handleClose } =
    props;
  return (
    <div>
      <div className="growegy-modal__close-button-container">
        <DivButton
          icon={<CloseIcon />}
          onClick={handleClose}
          dataTest="modal-header__close"
          className="growegy-modal__header-button"
        />
      </div>
      <div
        className={clsx('growegy-modal__title', {
          'flex-row': inlineTitleIcon,
          'align-items-center': inlineTitleIcon || centerTitle,
        })}
      >
        {titleIcon && <div className="flex-shrink-0">{titleIcon}</div>}
        <div className={clsx('growegy-font-em', titleClassName)} data-test="growegy-modal__title">
          {title}
        </div>
        {subTitle && (
          <div className="growegy-title14--moderat" data-test="growegy-modal__subtitle">
            {subTitle}
          </div>
        )}
      </div>
    </div>
  );
};
